import MicroModal from 'micromodal';

export const drawerConfig = () => {
  document.addEventListener('DOMContentLoaded', () => {
    const toggleButton = document.querySelector('.js-toggleButton');
    const closeButtons = document.querySelectorAll('.js-closeButton');
    const drawer = document.getElementById('drawer');
    const overlay = document.querySelector('.js-drawerOverlay');
    const inner = document.querySelector('.js-drawerInner');
    const headerLogo = document.querySelector('.js-headerLogo');

    function openDrawer() {
      overlay.classList.add('is-show');
      inner.classList.add('is-open');
      toggleButton.classList.add('is-active');
      headerLogo.classList.add('is-white');
      MicroModal.show('drawer', {
        disableScroll: true,
        awaitOpenAnimation: true,
      });
    }

    function closeDrawer() {
      overlay.classList.remove('is-show');
      inner.classList.remove('is-open');
      toggleButton.classList.remove('is-active');
      headerLogo.classList.remove('is-white');
      MicroModal.close('drawer', {
        awaitCloseAnimation: true,
      });
    }

    toggleButton.addEventListener('click', () => {
      if (drawer.classList.contains('is-open')) {
        closeDrawer();
      } else {
        openDrawer();
      }
    });

    closeButtons.forEach((closeButton) => {
      closeButton.addEventListener('click', () => {
        closeDrawer();
      });
    });
  });
};
